module.exports = __webpack_public_path__ + "6087a2811bf95f747a98e7fee7dc4dc8.pdf";